export const windowProvider = (): Window => window
